import React from 'react'
import SellForm from './Components/Javascript/Forms/SellForm'

export default function SellPage() {
  return (
    <div>
        <SellForm/>
    </div>
  )
}
